var link_viewer_wrapper_default = {
  "anchor": "_01E6t",
  "link": "Jqzpb"
};
export {
  link_viewer_wrapper_default as default
};
//# sourceMappingURL=link-viewer-wrapper-scss.js.map
